import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import PageHeader from "../components/common/PageHeader";
import { Icon } from '@iconify/react';
import { showToast } from '../helper/notifications';

const OverviewPage = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState({ 
    totalTopLocations: 0, 
    totalMainLocations: 0, 
    totalSubLocations: 0, 
    totalGooglePlaces: 0,
    totalGoogleBusiness: 0,
    totalUsers: 0 
  });
  const [loading, setLoading] = useState(false);

  const fetchStats = () => {
    api.get("/dashboard/stats")
      .then(res => setStats(res.data))
      .catch(err => {
        console.error(err);
        showToast("error", "Failed to refresh dashboard stats");
      });
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const handleManualSync = () => {
    setLoading(true);
    setTimeout(() => {
      fetchStats();
      setLoading(false);
      showToast("success", "Dashboard data synchronized");
    }, 600);
  };

  const cardData = [
    { 
      title: 'Master Data', 
      val: stats.totalMainLocations ?? 0, 
      icon: 'solar:buildings-bold', 
      gradient: '2', 
      circle: 'purple',
      link: '/locations-main',
      subtitle: 'Core Business Locations'
    },
    { 
      title: 'Google Places', 
      val: stats.totalGooglePlaces ?? 0, 
      icon: 'ri:google-fill', 
      gradient: '4', 
      circle: 'warning-main',
      link: '/locations-google',
      subtitle: 'Imported Google Places'
    },
    { 
      title: 'Google Business Profile', 
      val: stats.totalGoogleBusiness ?? 0, 
      icon: 'solar:shop-2-bold', 
      gradient: '5', 
      circle: 'primary-600',
      link: '/google-business',
      subtitle: 'Active Business Profiles'
    },
    { 
      title: 'Top Locations', 
      val: stats.totalTopLocations ?? 0, 
      icon: 'solar:map-point-bold', 
      gradient: '1', 
      circle: 'cyan',
      link: '/locations-top',
      subtitle: 'Parent Areas & Regions'
    },
    { 
      title: 'Sub Locations', 
      val: stats.totalSubLocations ?? 0, 
      icon: 'solar:shop-bold', 
      gradient: '3', 
      circle: 'info',
      link: '/locations-sub',
      subtitle: 'Units & Sub-facilities'
    },
    { 
      title: 'Authorized Users', 
      val: stats.totalUsers ?? 0, 
      icon: 'solar:user-bold', 
      gradient: '4', 
      circle: 'success-main',
      link: '/users',
      subtitle: 'Admin & Editor Accounts'
    },
  ];

  return (
    <>
      <PageHeader
        title="Dashboard"
        subtitle="Overview of core business locations, Google profiles, and authorized users."
        actions={
          <button 
            onClick={handleManualSync} 
            disabled={loading}
            className="btn btn-primary-600 radius-8 px-20 py-11 d-flex align-items-center gap-2"
          >
            <Icon icon={loading ? "line-md:loading-twotone-loop" : "solar:restart-bold"} />
            Refresh Stats
          </button>
        }
      />
      
      <div className="row row-cols-xxxl-6 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4">
        {cardData.map((card, i) => (
          <div className="col" key={i}>
            <div 
              className="card qiu-stat-card h-100 cursor-pointer transition-all"
              onClick={() => card.link && navigate(card.link)}
              style={{ cursor: "pointer" }}
            >
              <div className="card-body p-24 d-flex flex-column justify-content-between">
                <div className="d-flex flex-wrap align-items-start justify-content-between gap-3">
                  <div>
                    <p className="qiu-stat-label mb-8">{card.title}</p>
                    <h4 className="qiu-stat-value mb-0">{card.val}</h4>
                  </div>
                  <div className="qiu-stat-icon d-flex justify-content-center align-items-center">
                    <Icon icon={card.icon} className="text-xl mb-0" />
                  </div>
                </div>
                <p className="qiu-stat-footer text-xs mt-20 pt-12 mb-0 d-flex align-items-center justify-content-between">
                  <span>{card.subtitle}</span>
                  <Icon icon="solar:arrow-right-linear" className="text-sm qiu-stat-arrow" />
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default OverviewPage;